module.exports = __webpack_public_path__ + "img/six-bg2.edf2d885.png";